export class AIPromptCore {
  questionId: string;
  referenceId: string;
  turnId?: string;
  answerAudioId: string;
  answerAudioUrl: string;
  answerText: string;

  constructor(
    public questionText: string,
    public completed: boolean = false
  ) {}
}
